import { css, keyframes } from '@emotion/react';
import styled from '@emotion/styled';

import { withOpacity } from '@hrworks/design-system/functions';

import { mq } from '../../util/mediaQueries';

const fadeIn = keyframes({
  from: { opacity: 0 },
  to: { opacity: 1 },
});

const slideLeft = keyframes({
  from: { opacity: 0, transform: 'translateX(-30px)' },
  to: { opacity: 1, transform: 'translateX(0)' },
});

const slideRight = keyframes({
  from: { opacity: 0, transform: 'translateX(30px)' },
  to: { opacity: 1, transform: 'translateX(0)' },
});

const Overlay = styled.div(({ theme }) => ({
  position: 'fixed',
  inset: 0,
  zIndex: theme.variables.zIndex.modal,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: withOpacity(theme.eclipseTier2Color.background.neutral.bold.default, '85%'),
  [mq.conditionalTransition]: {
    animation: `${fadeIn} ${theme.variables.animationDuration.normal} ease-out`,
  },
}));

const ImageContainer = styled.div({
  position: 'relative',
  maxWidth: '90vw',
  maxHeight: '90vh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '& img': {
    maxWidth: '90vw',
    maxHeight: '85vh',
    objectFit: 'contain',
  },
});

const CloseButton = styled.div(({ theme }) => ({
  position: 'absolute',
  top: theme.eclipseTier1.spacing['16px'],
  right: theme.eclipseTier1.spacing['16px'],
  zIndex: theme.variables.zIndex.popover,
}));

const PrevButton = styled.div(({ theme }) => ({
  position: 'absolute',
  top: '50%',
  left: theme.eclipseTier1.spacing['16px'],
  transform: 'translateY(-50%)',
  zIndex: 1,
}));

const NextButton = styled.div(({ theme }) => ({
  position: 'absolute',
  top: '50%',
  right: theme.eclipseTier1.spacing['16px'],
  transform: 'translateY(-50%)',
  zIndex: 1,
}));

export const slideFromLeft = css({
  [mq.conditionalTransition]: {
    animation: `${slideLeft} 0.3s ease-out`,
  },
});

export const slideFromRight = css({
  [mq.conditionalTransition]: {
    animation: `${slideRight} 0.3s ease-out`,
  },
});

export const S = {
  Overlay,
  ImageContainer,
  CloseButton,
  PrevButton,
  NextButton,
} as const;
